import { IPostReqUserRegisterBuilding, IPostResUserRegisterBuilding, TSFixMe } from '../../frontend-libs/evlapp-types';
import { RestApi } from '../../common/services';
import { IAdminRegistration } from '../Admin/interfaces';

export const checkEmailAvailable = async (email?: string): Promise<'exists' | 'available'> => {
  if (!email) return 'exists';
  const res = await RestApi.post<{ email: string }, TSFixMe>(`/public/user/profile/email-exists`, { email: email });
  return res.exists !== true ? 'available' : 'exists';
};

export const sendFailedRegistrationEmail = async (values: TSFixMe): Promise<void> => {
  return await RestApi.post<TSFixMe, void>(`/public/register/save-fallback-contact`, {
    fallbackContactData: { ...values, user: { ...values.user, password: '' } },
  });
};

/**
 * @param {IAdminRegistration} values - values from Manager registration process
 * @return {Promise<TSFixMe>}
 */
export const registerAdmin = async (values: IAdminRegistration): Promise<TSFixMe> => {
  return await RestApi.post<IAdminRegistration, TSFixMe>('/security/register/admin', values);
};

/**
 * Registrace další budovy pod již přihlášený účet (uživatel se stává jejím adminem).
 */
export const registerBuilding = async (
  values: IAdminRegistration & { promoCode?: { code?: string } }
): Promise<IPostResUserRegisterBuilding> => {
  return await RestApi.post<IPostReqUserRegisterBuilding, IPostResUserRegisterBuilding>('/user/register/building', {
    building: { addressId: values.building.addressId },
    legalEntity: values.legalEntity,
    agreements: values.agreements,
    promoCode: values.promoCode,
  });
};

export const getBuildingsByAddress = async (value: string): Promise<TSFixMe> => {
  const res = await RestApi.post<{ q: string }, TSFixMe>(`/public/address-autocomplete`, { q: value });

  return res.hits;
};

export type AddressRegistrationStatus = 'available' | 'registered' | 'deactivated';

export const getAddressRegisteredStatus = async (
  addressId: string
): Promise<{ isRegistered: boolean; status: AddressRegistrationStatus }> => {
  return await RestApi.get(`public/address/is-registered/${addressId}`);
};

export interface IAddressLegalEntities {
  legalEntity: { name: string; companyId: string; taxId: string | null } | null;
  housingCooperativeName: string | null;
}

/**
 * SVJ sídlící na adrese (předvyplnění registračního formuláře) + bytové družstvo
 * (upozornění, že aplikace BD zatím nepodporuje). Data z ARES, best-effort.
 */
export const getAddressLegalEntities = async (addressId: string): Promise<IAddressLegalEntities> => {
  return await RestApi.get(`public/address/legal-entities/${addressId}`);
};

type IAdminBuildingInfo = IAdminRegistration;

export const getBuildingStatus = (values: IAdminBuildingInfo): Promise<TSFixMe> => {
  // if (values.user.password) values.user.password = '';
  return RestApi.post<TSFixMe, TSFixMe>(`/public/registration/summary`, {
    ...values,
    addressId: values.building.addressId,
  });
};
